module.exports = __webpack_public_path__ + "static/media/coins.b8d0c08f.mp3";